import axios from '../axios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/sysDept/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/sysDept/delete',
        method: 'post',
        data
    })
}
// 列表
export const list = (data) => {
    return axios({
        url: '/sysDept/list',
        method: 'post',
        data
    })
}
// 新增
export const edit = (data) => {
  return axios({
    url: '/sysDept/edit',
    method: 'post',
    data
  })
}
// 查看,编辑
export const view = (data) => {
  return axios({
    url: '/sysDept/view',
    method: 'post',
    data
  })
};
// 上移
export const moveUp = (data) => {
  return axios({
    url: '/sysDept/moveUpNode',
    method: 'post',
    data
  })
}
// 下移
export const moveDown = (data) => {
  return axios({
    url: '/sysDept/moveDownNode',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/dept.js